import { GlobalService } from './../../global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';


@Component({
  selector: 'app-route-wise-sale-statement',
  templateUrl: './route-wise-sale-statement.component.html',
  styleUrls: ['./route-wise-sale-statement.component.scss']
})
export class RouteWiseSaleStatementComponent implements OnInit {
  sessions: any;
  selected_date: any = null;
  selected_session_id: any = null;
  selected_route_id: any = null;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  routes: any;
  title: any;
  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
    this.httpService.getSession().subscribe((sessions: []) => {
      console.log(sessions);
      this.sessions = sessions;
    }, (error) => {
      console.log(error);
    });

    this.httpService.getRouteSessionWise().subscribe((data)=> {
      console.log(data);
      this.routes = data;
    }, (error) => {
      console.error(error);
    });
  }

  getClicked() {
    let data_dict = {
      'selected_date': this.selected_date,
      'selected_session_id': this.selected_session_id,
      'selected_route_id': this.selected_route_id
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.serveRouteWiseSaleStatement(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }


  changeEvent() {
    this.document_file = null;
  }
  
  
  ngOnInit() {
  }

}
